import React from "react";
import { User as UserModel } from "../../models/user";
import FooterBlock from "../../components/Footer/Footer";
import Leaderboard from "./components/Leaderboard";
import LoggedOutView from "../LoggedOutPage/LoggedOutPage";

interface LeaderboardProps {
  loggedInUser: UserModel | null;
}

const LeaderboardPage = ({ loggedInUser }: LeaderboardProps) => {
  return (
    <div className="startBellowNavbar pageBlock">
      {loggedInUser ? (
        <>
          <Leaderboard />
          <FooterBlock />
        </>
      ) : (
        <LoggedOutView />
      )}
    </div>
  );
};

export default LeaderboardPage;
